<template>
  <div>
    <MainBanner />
    <BoxesArea />
    <CloudHostingServices />
  </div>
</template>

<script>
import { onMounted } from 'vue'
import MainBanner from '../components/MainBanner.vue'
import BoxesArea from '../components/BoxesArea.vue'
import CloudHostingServices from '../components/CloudHostingServices.vue'
import { updateMetaTags, addStructuredData } from '../utils/seo'

export default {
  name: 'HomePage',
  components: {
    MainBanner,
    BoxesArea,
    CloudHostingServices
  },
  setup() {
    onMounted(() => {
      // Set SEO meta tags
      updateMetaTags({
        title: 'AtOnline - Enterprise Solutions for Business',
        description: 'AtOnline provides enterprise-grade solutions for content management, file storage, global management, mailing lists, and telephony services.',
        keywords: 'enterprise solutions, content management, file storage, kakari, mailing lists, telephony',
        type: 'website'
      })
      
      // Add structured data
      addStructuredData({
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "AtOnline",
        "url": "https://www.atonline.com",
        "logo": "https://www.atonline.com/img/logo_square_transp.png",
        "description": "Enterprise-grade solutions for content management, file storage, global management, mailing lists, and telephony services.",
        "parentOrganization": {
          "@type": "Organization",
          "name": "Karpeles Lab Inc",
          "url": "https://klb.jp"
        }
      })
    })
  }
}
</script>

<style scoped>
/* Home page specific styles */
</style>